module.exports = __webpack_public_path__ + "assets/img/third-screenshot.752f83f8.png";